(ns com.theplantscape.plant-web.api.plants
  (:require
   [com.theplantscape.browser-utils.ensemble :refer [open-in-new-tab]]
   [com.theplantscape.plant-web.draw.api :as api]
   [com.theplantscape.plant-web.draw.constants :refer [api-url-build]]
   [com.theplantscape.plant-web.draw.state :refer [app-state site-state]]))

(defn map-remove-nils [m]
  (into {} (remove (comp nil? second) m)))

(defn share-svg-url [diagram]
  (open-in-new-tab
   (api-url-build "/api/v2/diagrams/svg/" diagram)))

(defn add-new-plant-image
  [plant cb]
  (api/make-request
   {:method :post
    :uri (api-url-build "/api/v2/plant/image")
    :headers {:authorization "syt_b2x5_ZhcyOdWNiIWDmZkAYTnn_1d2gnN" #_(-> @site-state :auth :access_token)}
    :body plant}
   cb))


(defn share-svg [diagram cb]
  (api/make-request
   {:method :get
    :uri (api-url-build "/api/v2/diagrams/svg/" diagram)
    :headers {:authorization "syt_b2x5_ZhcyOdWNiIWDmZkAYTnn_1d2gnN" #_(-> @site-state :auth :access_token)}}
   cb))

(defn add-new-plant
  [plant cb]
  (api/make-request
   {:method :post
    :uri (api-url-build "/api/v2/plant")
    :headers {:authorization (-> @site-state :auth :access_token)}
    :params plant}
   cb))

(defn fetch-users-list
  ([list cb] (fetch-users-list list nil cb))
  ([list version cb]
   (api/make-request
    {:method :get
     :uri (api-url-build "/api/v2/list/plants/view/" list)
     :headers {:authorization (-> @site-state :auth :access_token)}
     :params (merge {} (when version {:revision version}))}
    cb)))

(defn fetch-users-lists
  ([cb] (fetch-users-lists nil cb))
  ([version cb]
   (api/make-request
    {:method :get
     :uri (api-url-build "/api/v2/list/plants/")
     :headers {:authorization (-> @site-state :auth :access_token)}
     :params (merge {} (when version {:revision version}))}
    cb)))

(defn rm-plant-list
  [plant-list cb]
  (api/make-request
   {:method :delete
    :uri (api-url-build "/api/v2/list/plants/remove/" plant-list)
    :headers {:authorization (-> @site-state :auth :access_token)}
    :params plant-list}
   cb))

(defn fetch-users-plant-lists
  ([] (fetch-users-plant-lists nil))
  ([version]
   (api/make-request-async
    {:method :get
     :uri (api-url-build "/api/v2/list/plants/")
     :headers {:authorization (-> @site-state :auth :access_token)}
     :params (merge {} (when version {:revision version}))})))

(defn create-new-plant-list
  [plant-list]
  (api/make-request-async
   {:method :post
    :uri (api-url-build "/api/v2/plant/collection/create")
    :headers {:authorization (-> @site-state :auth :access_token)}
    :params plant-list}))

(defn add-new-plant-list
  [plant-list cb]
  (api/make-request
   {:method :post
    :uri (api-url-build "/api/v2/list/plants/add")
    :headers {:authorization (-> @site-state :auth :access_token)}
    :params plant-list}
   cb))

(defn search-plants
  [search cb]
  (api/make-request
   {:method :get
    :uri (api-url-build "/api/v2/search/plant")
    :headers {:authorization (-> @site-state :auth :access_token)}
    :params (map-remove-nils search)}
   cb
   #_(fn [r]
     ;; json does not do keywords so convert back from string
     
     (-> r ;(mapv #(update %1 :type keyword) (:plants r))
         ))))

(defn fetch-plant-fallback
  ([{:keys [id] :as plant} cb error-cb]
   (api/make-request
    {:method :get
     :uri (api-url-build "/api/v2/plant")
     ;; :headers {:authorization (-> @site-state :auth :access_token)}
     :error-handle error-cb
     :params {:plant-id id}}
    cb)))

(defn fetch-plant-families-async
  ([family]
   (api/make-request-async
    {:method :get
     :uri (api-url-build "/api/v2/plant/families")
     :headers {:authorization (-> @site-state :auth :access_token)}
     :params (merge {:family family})})))

(defn fetch-plants-async
  ([plant-ids]
   (api/make-request-async
    {:method :post
     :uri (api-url-build "/api/v2/plants")
     :headers {:authorization (-> @site-state :auth :access_token)}
     :params plant-ids})))

(defn fetch-plant-async
  ([identifier] (fetch-plant-async identifier nil))
  ([identifier version]
   (api/make-request-async
    {:method :get
     :uri (api-url-build "/api/v2/plant")
     :headers {:authorization (-> @site-state :auth :access_token)}
     :params (merge {:plant-id identifier} (when version {:revision version}))})))

(defn fetch-plant
  "deprecate "
  ([identifier cb] (fetch-plant identifier nil cb))
  ([identifier version cb]
   (api/make-request
    {:method :get
     :uri (api-url-build "/api/v2/plant")
     ;; :headers {:authorization (-> @site-state :auth :access_token)}
     :params (merge {:plant-id identifier} (when version {:revision version}))}
    cb
    #_(prn "ajax fetch diagram"))))

(comment
  (search-plants {:search "rasp"} prn)
  (fetch-plant "lycium-barbarum" prn)
  (fetch-plant :string
               (fn [plant]
                 (swap! app-state assoc :plant plant)))

  (fetch-plant :string "0"
               (fn [plant]
                 (swap! app-state assoc :plant plant)))

  (fetch-plant :string "4"
               (fn [plant]
                 (swap! app-state assoc :plant plant))))
